import Link from "next/link";
import type { SimplePaginationLink as SimplePaginationLinkTypes } from "@motain/xpa-proto-files-web/lib/types/simple_pagination";
import classNames from "classnames";
import styles from "./SimplePaginationLink.module.scss";
import { isNullable } from "@/types/isNullable";

type SimplePaginationLinkProps = SimplePaginationLinkTypes & {
  kind: "prev" | "next";
};

export const SimplePaginationLink: React.FC<SimplePaginationLinkProps> = (
  props,
) => {
  const { link, isDisabled, kind } = props;

  if (isNullable(link)) {
    return null;
  }

  return (
    <>
      {!isDisabled ? (
        <Link
          className={classNames("title-8-medium", styles.link)}
          href={{
            pathname: link.urlPath,
            query: link.queryParams,
          }}
          aria-label={link.name}
        >
          <span
            className={classNames(
              "title-8-medium",
              kind === "prev" && styles.linkTextPrev,
            )}
          >
            {link.name}
          </span>
          <svg
            className={classNames(
              styles.arrow,
              kind === "prev" && styles.linkTextArrowPrev,
            )}
            fill="none"
            viewBox="0 0 7 10"
          >
            <path
              d="M1.6899 1l3.69 4-3.69 4"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
        </Link>
      ) : (
        <div
          className={classNames(
            "title-8-medium",
            styles.link,
            styles.linkDisabled,
          )}
        >
          <span
            className={classNames(
              "title-8-medium",
              kind === "prev" && styles.linkTextPrev,
            )}
          >
            {link.name}
          </span>
          <svg
            className={classNames(
              styles.arrow,
              kind === "prev" && styles.linkTextArrowPrev,
            )}
            fill="none"
            viewBox="0 0 7 10"
          >
            <path
              d="M1.6899 1l3.69 4-3.69 4"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
        </div>
      )}
    </>
  );
};
